// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --aura-navy: #0f172a;
  --aura-navy-light: #1e293b;
  --aura-navy-lighter: #334155;
  --aura-slate: #64748b;
  --aura-light-slate: #94a3b8;
  --aura-white: #f8fafc;
  --aura-teal: #14b8a6;
  --aura-blue: #0ea5e9;
  --aura-purple: #8b5cf6;
  --aura-magenta: #ec4899;
}

html{
    /* For Firefox */
    scrollbar-width: thin;
    /* For WebKit browsers */
    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: darkgrey;
        border-radius: 10px;
    }
}

body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
.w-130{
  width: 130px;
}

.w-0px{
  width: 0 !important;
}

.h-0px{
  height: 0 !important;
}

.role_values_layout{
  display: flex;
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB;QACI,UAAU;IACd;IACA;QACI,0BAA0B;QAC1B,mBAAmB;IACvB;AACJ;;AAEA;IACI,SAAS;IACT;;gBAEY;IACZ,mCAAmC;IACnC,kCAAkC;EACpC;;EAEA;IACE;eACW;EACb;AACF;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB","sourcesContent":["\n:root {\n  --aura-navy: #0f172a;\n  --aura-navy-light: #1e293b;\n  --aura-navy-lighter: #334155;\n  --aura-slate: #64748b;\n  --aura-light-slate: #94a3b8;\n  --aura-white: #f8fafc;\n  --aura-teal: #14b8a6;\n  --aura-blue: #0ea5e9;\n  --aura-purple: #8b5cf6;\n  --aura-magenta: #ec4899;\n}\n\nhtml{\n    /* For Firefox */\n    scrollbar-width: thin;\n    /* For WebKit browsers */\n    &::-webkit-scrollbar {\n        width: 8px;\n    }\n    &::-webkit-scrollbar-thumb {\n        background-color: darkgrey;\n        border-radius: 10px;\n    }\n}\n\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n      sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  \n  code {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n      monospace;\n  }\n.w-130{\n  width: 130px;\n}\n\n.w-0px{\n  width: 0 !important;\n}\n\n.h-0px{\n  height: 0 !important;\n}\n\n.role_values_layout{\n  display: flex;\n  justify-content: end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
